export const serviceTypes = {
    GRPC: "grpc",
    HTTP: "http",
    JSONRPC: "jsonrpc",
    PROCESS: "process",
};
